// extracted by mini-css-extract-plugin
export default {"features":"Features_features__pIUPi","content":"Features_content__XDLd5","contentHeading":"Features_contentHeading__byS5U","cards":"Features_cards__AMGlp"};